(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68b11cc9e9f15e52450a486c";
              window.beaePageSetting.pageTitle = "Foot"; 
              window.beaePageSetting.pageType = "footer";

          let js_H1FNDEVA = () => { let BeaeUseHooks = {};}; if (window.BEAEBASE) {js_H1FNDEVA()} else {window.BEAEPAGEJS.push(js_H1FNDEVA)} })(); 